export const COMPANY = {
  name: "Ronalp Enseigne",
  legalName: "Ronalp Enseigne",
  tagline: "Enseignes lumineuses • Signalétique • Communication visuelle",
  baseline: "Conception • Fabrication • Installation",
  phone: "(+33) 6 10 44 38 64",
  phoneHref: "tel:+33610443864",
  email: "Info@ronalp.fr",
  emailHref: "mailto:Info@ronalp.fr",
  address: {
    street: "1103 Rue Grand Route",
    postalCode: "01630",
    city: "Saint-Jean-de-Gonville",
    region: "Ain",
    country: "France",
  },
  legal: {
    company: "LOSTA TECH",
    form: "SAS, société par actions simplifiée",
    siren: "103 764 270",
    siret: "103 764 270 00015",
    tva: "FR34103764270",
    rcs: "103 764 270 R.C.S. Bourg-en-Bresse",
    rcsDate: "21/04/2026",
    rcsCity: "Bourg-en-Bresse",
  },
  siteUrl: "https://seo-enseigne-led.preview.emergentagent.com",
  logo: "/ronalp-logo.png",
  areasShort: ["Ain", "Pays de Gex", "Haute-Savoie", "Lyon", "Genève", "Vaud"],
};

export const SECTORS = [
  { key: "commerces", label: "Commerces", desc: "Boutiques, prêt-à-porter, concept-stores : enseignes qui captent le flux piéton." },
  { key: "restaurants", label: "Restaurants", desc: "Enseignes drapeaux, néons et caissons chaleureux pour la restauration." },
  { key: "hotels", label: "Hôtels", desc: "Signalétique d'accueil et enseignes de toiture visibles de loin." },
  { key: "pharmacies", label: "Pharmacies", desc: "Croix lumineuses, logos LED et signalétique réglementaire." },
  { key: "concessions", label: "Concessions auto", desc: "Totems de marque, habillage de façade et grands formats." },
  { key: "garages", label: "Garages", desc: "Enseignes robustes et signalétique d'atelier durable." },
  { key: "immobilier", label: "Agences immobilières", desc: "Lettres boîtiers premium et vitrophanie dynamique." },
  { key: "medical", label: "Cabinets médicaux", desc: "Plaques professionnelles et signalétique sobre et lisible." },
  { key: "entreprises", label: "Entreprises & bureaux", desc: "Logos de façade, totems d'accueil et signalétique interne." },
  { key: "collectivites", label: "Collectivités", desc: "Signalétique directionnelle et mobilier d'information." },
];

export const WHY = [
  { title: "Fabricant, pas seulement graphiste", desc: "Nous usinons l'aluminium, l'inox et le plexiglas dans notre atelier, puis nous posons nous-mêmes. Un seul interlocuteur de l'étude à l'installation." },
  { title: "Expertise LED & éclairage", desc: "Rétroéclairage, éclairage direct, température de couleur maîtrisée : des enseignes lisibles le jour et spectaculaires la nuit." },
  { title: "Interventions France & Suisse", desc: "Ancrage dans le Pays de Gex, l'Ain, la Haute-Savoie, la région lyonnaise et toute la Suisse romande (Genève, Nyon, Lausanne)." },
  { title: "Pose sécurisée en hauteur", desc: "Travail sur nacelle, raccordement électrique aux normes et maintenance. Chantiers maîtrisés du gros commerce à la petite devanture." },
];
